/** Namespace хуков API: подключает только нужную операцию в компоненте. */
import {
	useConfirmEmail,
	useLogin,
	useRegister,
	useRequestPasswordReset,
	useResetPassword,
} from "./auth";
import {
	useBlogArticle,
	useCreateBlogArticle,
	useDeleteBlogArticle,
	useListBlogArticles,
	useUpdateBlogArticle,
} from "./blog";
import { useSendFeedback } from "./feedback";
import { useUploadImage } from "./files";
import { useTextureLibrary } from "./internal";
import {
	useCreateProject,
	useDeleteProject,
	useListProjects,
	useProjectData,
	useSaveProjectData,
	useUpdateProject,
	useUpdateProjectSharing,
} from "./projects";
import {
	useCurrentUser,
	useDeleteCurrentUser,
	useListUsers,
	useUpdateCurrentUser,
	useUpdateUserEmail,
	useUpdateUserPassword,
	useUpdateUserRole,
	useUserProjects,
} from "./users";

export const apiHooks = {
	internal: {
		useTextureLibrary,
	},
	feedback: {
		useSendFeedback,
	},
	files: {
		useUploadImage,
	},
	auth: {
		useConfirmEmail,
		useLogin,
		useRegister,
		useRequestPasswordReset,
		useResetPassword,
	},
	blog: {
		useBlogArticle,
		useCreateBlogArticle,
		useDeleteBlogArticle,
		useListBlogArticles,
		useUpdateBlogArticle,
	},
	projects: {
		useCreateProject,
		useDeleteProject,
		useListProjects,
		useProjectData,
		useSaveProjectData,
		useUpdateProject,
		useUpdateProjectSharing,
	},
	users: {
		useCurrentUser,
		useDeleteCurrentUser,
		useListUsers,
		useUpdateCurrentUser,
		useUpdateUserEmail,
		useUpdateUserPassword,
		useUpdateUserRole,
		useUserProjects,
	},
};
